export const RecordStatus = {
  NoRecord: -1,
  Running: 0,
  Success: 1,
  Failed: 2
}

export const TranscriptsStatus = {
  NoMedia: -1,
  Running: 0,
  Success: 1,
  Failed: 2,
  Waiting: 3,
  NotStart: 4
}

export const AiTaskStatus = {
  NoText: -1,
  Running: 0,
  Success: 1,
  Failed: 2,
  Waiting: 3,
  NotStart: 4,
  NeedReStart: 5, // 需要重新生成
  Disabled: 6,
  MaxTokensLimit: 7,
}

export const SpokesmanTab = {
  label: '发言人',
  tab: 'spokesman',
}

export const InterviewTab = {
  label: '提问回顾',
  tab: 'chapter',
}

export const ChapterTab = {
  label: '章节',
  tab: 'chapter',
}

export const permissionTextMap = {
  schedule_participants: '日程参与者可见',
  schedule_organizer: '仅日程组织者可见',
  meeting_participants: '入会成员可见',
  meeting_creator: '仅发起者可见'
}

export const RecordViewPermissionRangeTextMap = {
  owner: 'initiator_only',
  schedule: 'schedule_participants',
  schedule_and_meeting: 'schedule_and_meeting_participants',
  meeting: 'meeting_member_only',
  company: 'participants_of_this_enterprise',
}

export const QA_STATUS = {
  answering: 'answering',
  stop: 'stop',
  break: 'break',
}

export const PROMPT_TAG = {
  qa: 'qa',
  shortcut_qa: 'shortcut_qa',
  shortcut_bar: 'shortcut_bar',
}

export const PROMPT_NAME = {
  /**
   * 用户提问
   */
  prompt: 'prompt',
  /**
   * 纪要总结
   */
  summary_text: 'summary_text',
  transcription: 'transcription',
  transcription_json: 'transcription_json',
  /**
   * 对话内容
   */
  text: 'text',
  /**
   * 附件文档
   */
  file_text: 'file_text',
}
// 校验时间格式 HH:mm 或者 HH:mm:ss
export const timePattern = /^\d{2}(:\d{2}){1,2}$/

export const dwTimeClickType = {
  aiContent: 'aiContent',
  chapter: 'chapter',
  transcripts: 'transcripts',
}

export const dwClickType = {
  'time': 'time',
  'version': 'version',
  'aiask': 'aiask',
}

export const KSO_AI = 'kso_ai_store'
